import Swiper from 'swiper';
import { Autoplay, Navigation, Pagination } from 'swiper/modules';

const selectors = {
  swiper: '.swiper',
  pagination: '.swiper-pagination',
  navigation: {
    next: '.swiper-button-next',
    prev: '.swiper-button-prev',
  },
};

class Slider {
  constructor(el, options = {}) {
    if (!el) return;

    this.swiperParent = el;
    this.swiperElement = this.swiperParent.querySelector(selectors.swiper);

    this.nextButton = this.swiperParent.querySelector(selectors.navigation.next);
    this.prevButton = this.swiperParent.querySelector(selectors.navigation.prev);
    this.pagination = this.swiperParent.querySelector(selectors.pagination);

    this.options = options;
    
    if (this.swiperElement) {
      this.initSwiper();
    }
  }
  

  initSwiper() {
    
    this.swiper = new Swiper(this.swiperElement, {
      init: false,
      modules: [Navigation, Pagination, Autoplay],
      navigation: {
        nextEl: this.nextButton,
        prevEl: this.prevButton,
      },
      pagination: {
        el: this.pagination,
        renderBullet: (index, className) => {
          return `
          <span class="${className} flex items-center justify-center">
            <svg class="default-icon w-2 h-2">
              <use href="#icon--circle"></use>
            </svg>
            <svg class="active-icon w-4 h-4">
              <use href="#icon--crosshair"></use>
            </svg>
          </span>
      `;
        },
      },
      ...this.options,
    });

    this.bindEvents();
    window.addEventListener('load', () => {
        this.swiper.init();
    })
  }

  bindEvents() {}
}

export default Slider;
